import React from "react";

export default function ThreeDotActionIcon() {
  return (
    <>
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12.75" cy="7.25" r="1.25" fill="#28303F" />
        <circle cx="12.75" cy="12.25" r="1.25" fill="#28303F" />
        <circle cx="12.75" cy="17.25" r="1.25" fill="#28303F" />
      </svg>
    </>
  );
}
